const BlogCardSkeleton = ({ className = 'col-lg-4 col-md-6' }) => {
  return (
    <div className={className}>
      <div className="blog__item">
        <div className="blog__item-inner">
          <div
            className="blog__thumb placeholder-glow rounded"
            style={{
              width: '100%',
              height: '266px',
              backgroundColor: '#e9ecef',
            }}
          ></div>
          <div className="blog__content blog__content--style2 mt-3">
            <div
              className="placeholder-glow rounded mb-2"
              style={{
                width: '70%',
                height: '20px',
                backgroundColor: '#e9ecef',
              }}
            ></div>

            <div className="d-flex justify-content-between mt-3">
              <div
                className="placeholder-glow rounded"
                style={{
                  width: '40%',
                  height: '16px',
                  backgroundColor: '#e9ecef',
                }}
              ></div>
              <div
                className="placeholder-glow rounded"
                style={{
                  width: '30%',
                  height: '16px',
                  backgroundColor: '#e9ecef',
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCardSkeleton;
